import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./index.css";

//* libreria fontawesone
/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// SweetAlert2 y SweetAlert CSS
import VueSweetalert2 from "vue-sweetalert2";

// router.beforeEach movido a router.js para centralización y evitar conflictos.

const options = {
  confirmButtonColor: "#000000",
  cancelButtonColor: "#ff7674",
};

/* import specific icons */
import {
  faCartPlus,
  faHouse,
  faCartShopping,
  faDolly,
  faAngleUp,
  faGauge,
  faCircleNotch,
  faBell,
  faChevronRight,
  faTrash,
  faPen,
  faStore,
  faUsers,
  faUserTie,
  faUserLock,
  faMicrochip,
  faPlus,
  faGears,
  faGear,
  faBuilding,
  faPeopleGroup,
  faCircleDollarToSlot,
  faPiggyBank,
  faSackXmark,
  faChartBar,
  faChartSimple,
  faChartPie,
  faTruck,
  faBasketShopping,
  faCheck,
  faBan,
  faKey,
  faRightToBracket,
  faDownload,
  faBarcode,
  faFolderOpen,
  faPrint,
  faEllipsis,
  faListUl,
  faSearch,
  faTicket,
  faDollarSign,
  faEye,
  faComputerMouse,
  faFile,
  faFileInvoice,
  faFileExcel,
  faFilePdf,
  faQuestion,
  faLandmark,
  faServer,
  faCubes,
  faCircleInfo,
  faFileImport,
  faClock,
  faCircleXmark,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";

import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

import "./registerServiceWorker";
/* add icons to the library */
library.add(
  faCartPlus,
  faHouse,
  faDolly,
  faAngleUp,
  faGauge,
  faCircleNotch,
  faBell,
  faChevronRight,
  faTrash,
  faPen,
  faCartShopping,
  faStore,
  faUsers,
  faUserTie,
  faUserLock,
  faMicrochip,
  faPlus,
  faGears,
  faGear,
  faBuilding,
  faPeopleGroup,
  faCircleDollarToSlot,
  faPiggyBank,
  faSackXmark,
  faChartBar,
  faChartSimple,
  faChartPie,
  faTruck,
  faBasketShopping,
  faCheck,
  faBan,
  faKey,
  faRightToBracket,
  faDownload,
  faBarcode,
  faFolderOpen,
  faPrint,
  faEllipsis,
  faListUl,
  faSearch,
  faTicket,
  faDollarSign,
  faEye,
  faComputerMouse,
  faFile,
  faFileInvoice,
  faFileExcel,
  faFilePdf,
  faQuestion,
  faLandmark,
  faServer,
  faCubes,
  faCircleInfo,
  faFileImport,
  faClock,
  faCircleXmark,
  faTriangleExclamation,
  faWhatsapp,
);
const app = createApp(App);
app.use(router);
app.use(VueSweetalert2, options);
app.component("font-awesome-icon", FontAwesomeIcon);
app.mount("#app");
